import type { Fallacy } from "./types";
import { createStory } from "./types";

export const redHerring: Fallacy = {
    id: "red-herring",
    name: "Red Herring",
    emoji: "🐟",
    category: "Argumen Lemah",
    description:
      "**Mengalihkan pembicaraan** ke topik lain yang tidak relevan untuk **menghindari inti masalah**.",
    detail:
      "Red Herring adalah taktik **mengalihkan perhatian dari topik utama** ke topik lain yang **tidak relevan**. Sering dipakai untuk menghindari pertanyaan sulit atau mengalihkan kritik.\n\nPola umum:\n1. Topik A sedang dibahas\n2. Seseorang memunculkan topik B yang tidak relevan\n3. Diskusi bergeser ke topik B\n4. Topik A tidak pernah dijawab\n\nCara melawan: Sadari pengalihan topiknya, lalu **kembalikan diskusi ke inti masalah**. \"Itu topik yang berbeda. Yang sedang kita bahas adalah...\"",
    tldr: "Lagi bahas A malah dibawa ke B. Pengalihan isu klasik.",
    story: createStory("Red Herring", "🐟", {
      hook: {
        title: "\"Korupsi proyek ini harus diusut!\"",
        body: "\"Yang penting jalan tolnya udah jadi, rakyat bisa pakai.\" — Oke, tapi **pertanyaan soal korupsinya belum dijawab.**",
      },
      convo: {
        claim: "Ditanya kenapa over budget bulan ini, jawabannya: **\"Tapi aku kan udah berhenti beli kopi Starbucks!\"**",
        response: "Bagus sih udah hemat kopi, tapi **pertanyaan kenapa over budget belum dijawab.**",
      },
      reveal: {
        body: "**Mengalihkan perhatian** dari topik utama ke topik lain yang gak relevan. Sering dipakai buat kabur dari pertanyaan sulit.",
      },
      insight: {
        title: "Kenapa ini efektif banget?",
        body: "Karena topik pengalihnya sering **kedengeran masuk akal**. Kamu baru sadar udah kealihkan setelah pertanyaan asli gak pernah terjawab.",
      },
      engagement: {
        title: "Siapa yang paling jago ngalihin topik di hidup kamu?",
        body: "Pacar, ortu, atau politisi? **Share pengalaman kamu di komen!** 👇",
      },
    }),
    related: ["straw-man", "tu-quoque", "appeal-to-emotion"],
  };
